const moduleFilterExtended = {
    namespaced: true,
    state: {
        showFilter: true,
    },
    getters: {
        getShowFilter(state) {
            return state.showFilter;
        },
    },
    mutations: {
        setShowFilter(state, showFilter) {
            state.showFilter = showFilter;
        },
    },
};
export default moduleFilterExtended;
